import React from "react";
import { Drawer, Descriptions, Tag } from "antd";

export default function RateLimitEventDrawer({
  open,
  onClose,
  event,
}) {
  if (!event) return null;

  return (
    <Drawer
      title="Rate Limit Event Details"
      open={open}
      onClose={onClose}
      size={600}
      zIndex={99999}
    >
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="ID">{event.id}</Descriptions.Item>

        <Descriptions.Item label="Client ID">
          {event.clientId}
        </Descriptions.Item>

        <Descriptions.Item label="API Key ID">
          {event.apiKeyId}
        </Descriptions.Item>

        <Descriptions.Item label="Path">
          {event.path}
        </Descriptions.Item>

        <Descriptions.Item label="Type">
          <Tag>{event.type}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Outcome">
          <Tag color={event.outcome === "BLOCKED" ? "red" : "green"}>
            {event.outcome}
          </Tag>
        </Descriptions.Item>

        <Descriptions.Item label="Reason">
          {event.reason}
        </Descriptions.Item>

        <Descriptions.Item label="Retry After">
          {event.retryAfter}
        </Descriptions.Item>

        <Descriptions.Item label="Remaining Path Requests">
          {event.remainingPathRequests}
        </Descriptions.Item>

        <Descriptions.Item label="Remaining Global Requests">
          {event.remainingGlobalRequests}
        </Descriptions.Item>

        <Descriptions.Item label="Reset Path Time">
          {event.resetPathTime}
        </Descriptions.Item>

        <Descriptions.Item label="Reset Global Time">
          {event.resetGlobalTime}
        </Descriptions.Item>

        <Descriptions.Item label="Created At">
          {new Date(event.createdAt).toLocaleString()}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}